import React, { useState } from 'react';
import { toMMDDYYYY } from '../utils/dateFormat';
import '../styles/transaction.css';

function TransactionModal({ store, onClose, onSave, existingTransaction = null }) {
  const isEditMode = !!existingTransaction;
  const [mode, setMode] = useState('manual'); // 'manual' or 'email'
  const [emailText, setEmailText] = useState('');
  const [formData, setFormData] = useState({
    type: existingTransaction?.type || 'income',
    amount: existingTransaction?.amount?.toString() || '',
    description: existingTransaction?.desc || ''
  });

  const parseEtsyEmail = (text) => {
    // Parse email subject: "Your funds of $5,156.58 USD are on the way!"
    const amountMatch = text.match(/\$([0-9,]+\.?\d*)/);
    
    if (amountMatch) {
      const amount = amountMatch[1].replace(/,/g, ''); // Remove commas
      setFormData({
        type: 'income',
        amount: amount,
        description: 'Etsy Payment'
      });
      setMode('manual'); // Switch to manual mode to review
      return true;
    }
    
    alert('Could not find amount in email text. Expected format: "Your funds of $123.45 USD"');
    return false;
  };

  const handleSubmit = async () => {
    if (!formData.amount || !formData.description) {
      alert('Amount and Description are required!');
      return;
    }

    const transaction = {
      id: Date.now(),
      date: toMMDDYYYY(new Date().toISOString().split('T')[0]),
      type: formData.type,
      amount: parseFloat(formData.amount),
      desc: formData.description
    };

    try {
      await onSave(transaction);
      onClose();
    } catch (e) {
      alert('Failed to save transaction. Please try again.');
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="transaction-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{isEditMode ? '✏️ Edit' : '💸 Add'} Transaction - {store.name || store.storeCode}</h3>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        {/* Mode Selection - Only show in Add mode */}
        {!isEditMode && (
          <div className="mode-selector">
            <button
              className={`mode-btn ${mode === 'manual' ? 'active' : ''}`}
              onClick={() => setMode('manual')}
            >
              ✍️ Manual Entry
            </button>
            <button
              className={`mode-btn ${mode === 'email' ? 'active' : ''}`}
              onClick={() => setMode('email')}
            >
              📧 Parse from Email
            </button>
          </div>
        )}

        <div className="modal-body">
          {!isEditMode && mode === 'email' ? (
            /* Email Parse Mode */
            <div className="email-parse-section">
              <div className="form-field">
                <label>📧 Paste Etsy Email Subject</label>
                <textarea
                  placeholder='Example: "Your funds of $5,156.58 USD are on the way!"'
                  value={emailText}
                  onChange={(e) => setEmailText(e.target.value)}
                  rows="4"
                  style={{
                    width: '100%',
                    padding: '12px',
                    borderRadius: '8px',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    background: 'rgba(255, 255, 255, 0.03)',
                    color: '#fff',
                    fontSize: '14px',
                    resize: 'vertical'
                  }}
                />
              </div>
              <button
                className="btn-parse"
                onClick={() => parseEtsyEmail(emailText)}
                disabled={!emailText}
                style={{
                  width: '100%',
                  padding: '12px',
                  background: 'linear-gradient(135deg, #d4af37, #c4941f)',
                  border: 'none',
                  borderRadius: '8px',
                  color: '#000',
                  fontWeight: '600',
                  cursor: emailText ? 'pointer' : 'not-allowed',
                  opacity: emailText ? 1 : 0.5
                }}
              >
                🔍 Parse Amount
              </button>
            </div>
          ) : (
            /* Manual Entry Mode */
            <>
              <div className="form-field">
                <label>Type</label>
                <div className="type-buttons">
                  <button
                    className={`type-btn ${formData.type === 'income' ? 'active income' : ''}`}
                    onClick={() => setFormData({ ...formData, type: 'income' })}
                  >
                    ➕ Income
                  </button>
                  <button
                    className={`type-btn ${formData.type === 'expense' ? 'active expense' : ''}`}
                    onClick={() => setFormData({ ...formData, type: 'expense' })}
                  >
                    ➖ Expense
                  </button>
                </div>
              </div>

              <div className="form-field">
                <label>Amount ($)</label>
                <input
                  type="number"
                  step="0.01"
                  placeholder="120.50"
                  value={formData.amount}
                  onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
                />
              </div>

              <div className="form-field">
                <label>Description</label>
                <input
                  type="text"
                  placeholder="Amazon Ads, Shopify Fee, Etsy Sales..."
                  value={formData.description}
                  onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                />
              </div>
            </>
          )}
        </div>

        <div className="modal-footer">
          <button className="btn-cancel" onClick={onClose}>Cancel</button>
          <button className="btn-save" onClick={handleSubmit}>
            {isEditMode ? '💾 Update' : '💾 Save'} Transaction
          </button>
        </div>
      </div>
    </div>
  );
}

export default TransactionModal;